import { useCallback } from "react";
import { apiService } from "../service/apiClient.js";
import { apiUrl } from "../service/apiUrl.js";

export const useNotificationsApi = () => {
  const fetchSubscribersApi = useCallback(async () => {
    const res = await apiService.get(apiUrl.notificationSubscribers());
    return res.data?.subscribers || [];
  }, []);

  const subscribeApi = useCallback(async (email) => {
    return apiService.post(apiUrl.notificationSubscribers(), { email });
  }, []);

  const unsubscribeApi = useCallback(async (id) => {
    return apiService.delete(apiUrl.notificationSubscriberById(id));
  }, []);

  return {
    fetchSubscribersApi,
    subscribeApi,
    unsubscribeApi,
  };
};

export default useNotificationsApi;
